export default (function(window) {

  return function() {
    return new Promise((resolve, reject) => {
      if (document.readyState === 'complete') {
        return resolve({ init: false });
      }

      window.addEventListener('load', () => {
        resolve({ init: true });
      })
    })
  }
})(window);
